import { VisualSwitch } from 'components/VisualSwitch/VisualSwitch'
import { useField } from 'formik'

interface Props {
  name: string
}

export const BooleanInput = ({ name }: Props) => {
  const [field, , helpers] = useField(name)
  return (
    <div onClick={() => helpers.setValue(!field.value)}>
      <VisualSwitch variant="md" active={field.value} name={name} />
    </div>
  )
}
